import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import _ from "lodash";
import { AppNotifications, LanguageOutputModel, RootState, SolutionOutputModel, TCb } from "../../../../../models";
import { AllLanguageListActions, NotificationActions } from "../../../../../store/actions";
import { C_Props, C_States, MapDispatchToProps, MapStateToProps, MergedProps } from "./TechnologyList.type";

import { APP_ROUTES, BLOG_CATEGORY, CATEGORY_TYPES, INITIAL_FETCHING_PAGINATION_DATA } from "../../../../../constants";

import { withRouter } from "react-router-dom";
import { BlogService, CategoryService } from "../../../../../services";
import { TechnologyService } from "../../../../../services/technology.service";
import { loadCallback } from "../../../../../utils";
import { TechnologyUtil } from "../../../../../utils/technology.util";
import TechnologyListingPresenter from "./TechnologyList.presenter";

const EMPTY_FILTER: C_States["filter"] = {
  searchValue: "",
  categoryUrl: "",
};

class TechnologyListingContainer extends React.Component<MergedProps, C_States> {
  constructor(props) {
    super(props);
    const solutionPageCode = this.props.match.params.solutionCode;

    this.state = {
      filter: EMPTY_FILTER,
      fetchedSolution: INITIAL_FETCHING_PAGINATION_DATA,
      visibleSolutionCode: solutionPageCode,
      visibleSolutionForm: Boolean(solutionPageCode),

      activeLanguageId: "",
      languageData: [],
      amountPost: 0,
      categories: [],

      visibleCategoryId: undefined,
      visibleCategoryForm: false,
    };
  }

  openSolutionFormModal = (solutionCode?: string) => {
    this.setState({ visibleSolutionCode: solutionCode, visibleSolutionForm: true }, () => {
      if (solutionCode) {
        this.props.history.push(TechnologyUtil.buildTechnologyDetailPath(solutionCode));
      }
    });
  };

  closeSolutionFormModal = (cb?: TCb) => {
    this.props.history.push(APP_ROUTES.PAGEMANAGEMENT.TECHNOLOGY.BASE);
    this.setState({ visibleSolutionCode: undefined, visibleSolutionForm: false }, () => {
      loadCallback(cb?.success);
    });
  };

  openCategoryForm = (code?: string) => {
    this.setState({ visibleCategoryId: code, visibleCategoryForm: true }, () => {});
  };

  closeCategoryForm = (cb?: TCb) => {
    this.setState({ visibleCategoryId: undefined, visibleCategoryForm: false }, () => {
      loadCallback(cb?.success);
    });
  };

  countPost = (dataPost: SolutionOutputModel[]) => {
    const data: any = dataPost;
    const uniqueObj = {};
    for (var i = 0; i < data.length; i++) {
      uniqueObj[data[i]] = 1 + (uniqueObj[data[i]] || 0);
    }
    const count = uniqueObj[Object.keys(uniqueObj)[Object.keys(uniqueObj).length - 1]];
    // Khi data = [] => count: undefined
    if (count) {
      this.setState({
        amountPost: count,
      });
    }
  };

  onDeleteCategory = (code: string | null) => {
    code &&
      CategoryService.deleteCategory(code!)
        .then((res) => {
          if (res && (res.status === 200 || res.status === 201)) {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.SUCCESS,
              message: "Delete category success",
            });
            this.onApplyFilter(false);
          } else {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Delete category failed",
            });
          }
        })
        .catch((err) => {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Delete category failed",
          });
        });
  };

  onSearch = _.debounce((searchValue: string) => {
    this.setState(
      (prevState) => {
        return {
          filter: {
            ...prevState.filter,
            searchValue,
          },
        };
      },
      () => {
        this.onApplyFilter(false);
      },
    );
  }, 300);

  onLoadCategories = () => {
    BlogService.filterCategories({
      limit: 150,
      type: CATEGORY_TYPES.SOLUTION,
      languageId: this.props.all_language_list.data.find((e: LanguageOutputModel) => e.isPrimary)?.id,
    })
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          // let cate: BlogCategoryOutputModel[] = [...res.data.data];
          // this.setState({ categories:  cate });

          let cates: any[] = res.data.data;

          cates = cates.filter((cate) => cate.id !== BLOG_CATEGORY.PROMOTION.id);
          this.setState({ categories: cates });
        }
      })
      .catch((err) => {
        this.setState({
          categories: [],
        });
      });
  };

  onChangeCategory = (categoryUrl: string) => {
    this.setState(
      {
        filter: {
          ...this.state.filter,
          categoryUrl,
        },
      },
      () => {
        this.onApplyFilter(false);
      },
    );
  };

  onApplyFilter = async (loadMore: boolean, cb?: TCb) => {
    if (this.state.fetchedSolution.loading && loadMore) return;
    await this.onLoadCategories();

    this.props.all_language_list.data.forEach((e: LanguageOutputModel) => {
      if (e.isPrimary) {
        this.setState({
          activeLanguageId: e.id,
        });
      }
    });

    this.setState(
      (prevState) => {
        return {
          fetchedSolution: {
            ...prevState.fetchedSolution,
            data: loadMore ? prevState.fetchedSolution.data : [],
            loading: true,
          },
        };
      },
      () => {
        const query: Parameters<typeof TechnologyService.getAllTechnologyPageByLanguage>[0] = {
          languageId: this.props.all_language_list.data.find((e: LanguageOutputModel) => e.isPrimary)?.id,
          categoryId: this.state.filter.categoryUrl,
        };

        TechnologyService.getAllTechnologyPageByLanguage(query)
          .then((res) => {
            this.countPost(res.data.data);
            if (res && res.data?.data) {
              this.setState(
                (prevState) => {
                  let solutionPages: SolutionOutputModel[] = [...res.data.data];

                  if (loadMore) {
                    solutionPages.unshift(...prevState.fetchedSolution.data);
                  }

                  return {
                    fetchedSolution: {
                      ...res.data,
                      data: solutionPages,
                      loading: false,
                    },
                  };
                },
                () => {
                  loadCallback(cb?.success);
                },
              );
            } else {
              this.setState({
                fetchedSolution: INITIAL_FETCHING_PAGINATION_DATA,
              });
            }
          })
          .catch((err) => {
            this.setState({
              fetchedSolution: INITIAL_FETCHING_PAGINATION_DATA,
            });
          });
      },
    );
  };

  onDeleteBlog = (code: string | null) => {
    code &&
      TechnologyService.deleteTechnologyPage(code!)
        .then((res) => {
          if (res && (res.status === 200 || res.status === 201)) {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.SUCCESS,
              message: "Delete blog success",
            });
            this.onApplyFilter(false);
          } else {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Delete blog failed",
            });
          }
        })
        .catch((err) => {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Delete blog failed",
          });
        });
  };

  onLoadMore = () => {
    this.onApplyFilter(true);
  };

  componentDidMount() {
    if (!this.props.all_language_list.data.length) {
      this.props.actions.getAllLanguages({
        success: () => {
          this.onApplyFilter(false);
        },
      });
    } else {
      this.onApplyFilter(false);
    }
  }

  render() {
    return (
      <TechnologyListingPresenter
        {...this.props}
        {...this.state}
        onLoadMore={this.onLoadMore}
        onSearch={this.onSearch}
        openSolutionFormModal={this.openSolutionFormModal}
        closeSolutionFormModal={this.closeSolutionFormModal}
        reloadListingPage={() => {
          this.onApplyFilter(false);
        }}
        reloadListingCatePage={() => {
          this.onLoadCategories();
        }}
        onChangeCategory={this.onChangeCategory}
        openCategoryForm={this.openCategoryForm}
        closeCategoryForm={this.closeCategoryForm}
        onDeleteCategory={this.onDeleteCategory}
        onDeleteBlog={this.onDeleteBlog}
      />
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,
    }),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions, AllLanguageListActions), dispatch),
    }),
  )(TechnologyListingContainer),
);
